"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.linkTarget = exports.linkUrl = void 0;

var linkUrl = function linkUrl(targetUrl) {
  if (!targetUrl) return null;
  var url = /^((http|https):\/\/)/;

  if (url.test(targetUrl)) {
    return targetUrl;
  } else {
    return window.location.origin + '/' + targetUrl;
  }
};

exports.linkUrl = linkUrl;

var linkTarget = function linkTarget(targetUrl) {
  if (!targetUrl) return null;
  var url = /^((http|https):\/\/)/;
  return url.test(targetUrl) ? '_blank' : '_self';
};

exports.linkTarget = linkTarget;